import { useContext } from 'react'
import { ProcessedMessage } from './useProcessMessage'
import PopupContext from '../../context/PopupContext'

/**
 * Messages originating from the Inboxer in order to invoke the file-this-e-mail popup.
 */
export type EmailFilingSuggestNotification = ProcessedMessage<{
    messageId: string
    userEmail: string
}>

/**
 * Process an e-mail filing suggest event message. This opens the popup straight away (HAM-4278); it used to route to
 * /command/email-filing-suggest, which meant pushing a background location around only to show a dialog.
 */
export default function useProcessEmailFilingSuggestNotification() {
    const { setShowEmailFilingDialog } = useContext(PopupContext)

    return (message: EmailFilingSuggestNotification) => {
        if (message.data.messageId === undefined) {
            return
        }

        setShowEmailFilingDialog(message.data)
    }
}
